import { useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import SwAlert from "../components/SwAlert";
import { actions, isReadOnly, loadUnits as fetchUnits } from "../store/ducks/unit.duck";

/**
 * Unidade (matriz ou filial) escolhida no seletor da navegação.
 *
 * A escolha vale para o painel inteiro: as páginas usam `selectedUnit` para travar os próprios filtros de
 * unidade e `readOnly` para esconder as ações de cadastro, edição e exclusão enquanto a matriz visualiza
 * os dados de uma filial.
 */
export default function useUnit() {
    const dispatch = useDispatch();

    const { units, ownUnitId, isParent, selectedUnit, loading } = useSelector((state) => state.unit);

    const loadUnits = useCallback(
        () =>
            fetchUnits(dispatch).catch((err) => {
                // `err.request` só existe quando a falha é da chamada em si; sem ele o erro veio do próprio helper.
                const message = err?.response?.data?.errors?.[0] ?? (err?.request ? null : err?.message);

                return SwAlert({
                    title: message ?? "Parece que houve um problema.",
                    text: message ? null : "Por favor, entre em contato com o suporte.",
                    confirmButtonText: "Fechar",
                    imageIcon: "error",
                });
            }),
        [dispatch],
    );

    const selectUnit = useCallback((unit) => dispatch(actions.selectUnit(unit)), [dispatch]);

    const readOnly = useMemo(() => isReadOnly({ selectedUnit, ownUnitId }), [selectedUnit, ownUnitId]);

    return { units, ownUnitId, isParent, selectedUnit, readOnly, loading, loadUnits, selectUnit };
}
